import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../service/modal.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-father-modal',
  templateUrl: './father-modal.component.html',
  styleUrls: ['./father-modal.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class FatherModalComponent {
  constructor(public modal: ModalService) { }
  @Input() childParams?: Record<string, unknown>;

}